import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import logo from "../Components/assets/images/logo.png";
import dashIcon from "../Components/assets/images/dash_icon.svg";
import userIcon from "../Components/assets/images/user_icon.svg";
import dollerIcon from "../Components/assets/images/doller_icon.svg";
import changepwd from "../Components/assets/images/changepwd.png";
import userImg from "../Components/assets/images/userImg.png";
import about from "../Components/assets/images/about.png";
import term from "../Components/assets/images/term.png";
import privacy from "../Components/assets/images/privacy.png";
import LogoutModal from "../Components/LogoutModal";
import { useEffect } from "react";

const Sidebar = () => {
  const auth = localStorage.getItem('token');
  let navigate = useNavigate();
  const pathname = window.location.pathname

  useEffect(() => {
      window.scrollTo(0, 0)
  }, [pathname])
  

	useEffect(() => {
		if(!auth || auth == '' || auth == undefined){
			navigate('/login')		}
	}, [auth]);
  

  return (
    <div className="sidebar">
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="popular" loading="lazy" />
        </Link>
      </div>
      <ul className="sidebarList">
        <li>
          <NavLink to="/">
            <span>
              <img src={dashIcon} alt="icon" />
            </span>
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/users">
            <span>
              <img src={userImg} alt="icon" />
            </span>
            Users Management
          </NavLink>
        </li>
        <li>
          <NavLink to="groups">
            <span>
              <img src={userIcon} alt="icon" />
            </span>
            Groups Management
          </NavLink>
        </li>

        <li>
          <NavLink to="/AppPurchase">
            <span>
              <img src={dollerIcon} alt="icon" />
            </span>
            InApp Purchases Management
          </NavLink>
        </li>
       
        <li>
          <NavLink to="/faqs">
            <span>
              <img src={about} alt="icon" />
            </span>
            FAQs
          </NavLink>
        </li>
        <li>
          <NavLink to="/term&condition">
            <span>
              <img src={term} alt="icon" />
            </span>
            Terms & Condition
          </NavLink>
        </li>
        <li>
          <NavLink to="/privacypolicy">
            <span>
              <img src={privacy} alt="icon" />
            </span>
            Privacy Policy
          </NavLink>
        </li>
        <li>
          <NavLink to="/changepassword">
            <span>
              <img src={changepwd} alt="icon" />
            </span>
            Change Password
          </NavLink>
        </li>
        <li>
          <a className="logout_btn">
            <LogoutModal />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
